import NewBooking from "./NewBookingHotel";

export default NewBooking;
